import React from "react"
import parse, { domToReact } from 'html-react-parser';
import { Script } from "gatsby";

import Link from 'components/Link'
import Image from 'components/Image'
import SmartAccordion from 'global/SmartAccordion'
import SmartSlider from 'global/SmartSlider'
import SmartGallery from 'global/SmartGallery'
import SmartQuickLinks from 'global/SmartQuickLinks'
import BeachConditionsFlag from 'global/BeachConditionsFlag'

let blacklist = []

const parseInlineStyle = (style) => {
    const declarations = style.split(';');
    const stylesObject = {};
    declarations.forEach(declaration => {
        const [property, value] = declaration.split(':').map(item => item.trim());
        const camelCaseProperty = property.replace(/-([a-z])/g, (match, letter) => letter.toUpperCase());
        if (camelCaseProperty && value) {
            stylesObject[camelCaseProperty] = value;
        }
    });

    return stylesObject;
}

const parserOptions = {
	htmlparser2: {
		lowerCaseTags: false
	},
	replace: (Element) => {
		const { name, attribs, children } = Element
		if (blacklist.includes(name)) return <></>;

		switch (name) {
			case "a":
				if (attribs && attribs.style) {
					attribs.style = parseInlineStyle(attribs.style);
				}
				attribs.className = attribs.class;
				delete attribs.class;
				return <Link {...attribs}>{domToReact(children, parserOptions)}</Link>

			case "img":
				if (attribs && attribs.style) {
					attribs.style = parseInlineStyle(attribs.style);
				}
				attribs.className = attribs.class;
				delete attribs.class;
				return <Image {...attribs} />

			case "smarttag":
				if (attribs.component !== undefined) {
					const { component } = attribs;
					delete attribs.component;
					for (const key in attribs) {
						if (attribs[key] === 'false') attribs[key] = false;
						if (attribs[key] === 'true') attribs[key] = true;
					}
					switch (component) {
						case 'Accordion':
							return (
								<>
									{<SmartAccordion {...attribs} />}
									{domToReact(children, parserOptions)}
								</>
							)

						case 'Slider':
							return (
								<>
									{<SmartSlider {...attribs} />}
									{domToReact(children, parserOptions)}
								</>
							)

						case 'Gallery':
							return (
								<>
									{<SmartGallery {...attribs} />}
									{domToReact(children, parserOptions)}
								</>
							)

						case 'Quicklink':
							return (
								<>
									{<SmartQuickLinks {...attribs} />}
									{domToReact(children, parserOptions)}
								</>
							)

						case 'Weather Conditions Status':
							return (
								<>
									{<BeachConditionsFlag {...attribs} />}
									{domToReact(children, parserOptions)}
								</>
							)

						default:
							return null;
					}
				}
				return null;

			case "script":
				return <Script strategy="idle">{domToReact(children, parserOptions)}</Script>

			default:
				return null;
		}
	}
};

export default function zparse(str, options = parserOptions, blacklistArr = []) {
	if (!str) return "";
	blacklist = blacklistArr
	return parse(str, options);
}